import {ILocationTranslation, ITextAndIcon} from "src/components/GeneralInterfaces";
import {ITypefamilyMap} from "src/redux/reducers/generalReducer";
import {UserDetailsDto, MenuDto, ResourceListOfModelyearDto, ResourceListOfWorkflowOptionApprovalDto, CnrDto, JobsDto} from "src/services/Client";
import HATEOASClient from "src/services/HATEOASClient";
import ViewContainer, {ICommonViewProps} from "../ViewContainer";
import {RouteComponentProps} from "react-router";
import React, {Dispatch} from "react";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {compose} from "redux";
import ApprovalViewActions from "src/redux/actions/ApprovalViewActions";
import {IReduxState} from "../../redux/IReduxState";
import GeneralActions from "../../redux/actions/GeneralActions";
import {selectModelyears, selectUserDetails, selectBaseLinks, selectClient, selectApprovals, selectCnrList, selectTypefamilyMap, selectLanguage} from "src/redux/selectors";
import ApprovalView from "../ApprovalView/ApprovalView";
import {Tab, TabProps} from "semantic-ui-react";
import BusinessTab from "./BusinessTab";
import TechnicalTab from "./TechanicalTab";
import TextTab from "./TextTab";
import ColumnFactory from "src/services/ColumnFactory";

interface IMapStateToProps {
    client: HATEOASClient;
    userDetails?: UserDetailsDto;
    baseLinks?: MenuDto;
    modelYears?: ResourceListOfModelyearDto;
    approvals?: ResourceListOfWorkflowOptionApprovalDto;
    cnrList?: CnrDto[];
    typefamilyMap?: ITypefamilyMap;
    userLanguage: string;

}

interface IMapDispatchToProps {
    addLoadingMessage: (message: string) => void;
    removeLoadingMessage: (message: string) => void;
    addTranslationLocation: (translation: ILocationTranslation) => void;
    ReceiveTranslationServiceAction: (translationService: any) => void;
}
interface IManagemntViewState {
    jobs?: JobsDto[];
    activeTab: number | string;
}

interface IManagementViewProps extends IMapStateToProps, IMapDispatchToProps, ICommonViewProps, RouteComponentProps<any> {
}

const createLinkName = (value: number, state: any): ITextAndIcon => {
    const {userModelyears} = state.general;
    const mj = userModelyears.elements ? userModelyears.elements.find((mjo: any) => mjo.objectId === value) : undefined;
    const sval = !mj ? value : ColumnFactory.mj2str(mj);
    return {text: "MODELYEAR_VALUE", options: {value: sval}, noTranslation: false};
};
/**
 * A container view for Approvals
 */
class ManagementView extends React.Component<IManagementViewProps, IManagemntViewState> {

    constructor(props: IManagementViewProps) {
        super(props);
        this.state = {
            jobs: [],
            activeTab: 0
        };
    }
    componentDidMount(): void {
        this.props.addTranslationLocation({pattern: "managementview", substitutes: "MANAGEMENT VIEW"});
    }

    render() {
        const {client, baseLinks, modelYears} = this.props;
        const hasSupportRole = baseLinks && client.GET_supportArea(baseLinks).canExecute();
        const hasBusinessRole = baseLinks && client.GET_managementBusinessArea(baseLinks).canExecute();
        const panes = [];
        if (hasBusinessRole) {
            panes.push({
                menuItem: this.props.t("BUSINESS_TAB"),
                render: () => (
                    <Tab.Pane attached={false}>
                        <BusinessTab
                            client={client}
                            baseLinks={baseLinks}
                            addLoadingMessage={this.props.addLoadingMessage}
                            removeLoadingMessage={this.props.removeLoadingMessage}
                            t={this.props.t}
                            ReceiveTranslationServiceAction={this.props.ReceiveTranslationServiceAction}
                        />
                    </Tab.Pane>
                )
            });
        }
        if (hasSupportRole) {
            panes.push({
                menuItem: this.props.t("TECHNICAL_TAB"),
                render: () => (
                    <Tab.Pane attached={false}>
                        <TechnicalTab
                            modelYears={modelYears}
                            client={client}
                            baseLinks={baseLinks}
                            addLoadingMessage={this.props.addLoadingMessage}
                            removeLoadingMessage={this.props.removeLoadingMessage}
                            t={this.props.t}
                            ReceiveTranslationServiceAction={this.props.ReceiveTranslationServiceAction}
                        />
                    </Tab.Pane>
                )
            });
        }
        if (hasBusinessRole) {
            panes.push({
                menuItem: this.props.t("TEXT_TAB"),
                render: () => (
                    <Tab.Pane attached={false}>
                        <TextTab
                            client={client}
                            baseLinks={baseLinks}
                            addLoadingMessage={this.props.addLoadingMessage}
                            removeLoadingMessage={this.props.removeLoadingMessage}
                            t={this.props.t}
                            ReceiveTranslationServiceAction={this.props.ReceiveTranslationServiceAction}
                        />
                    </Tab.Pane>
                )
            });
        }
        return (
            <ViewContainer>
                <Tab
                    menu={{attached: true, tabular: true}}
                    onTabChange={(event: React.MouseEvent<HTMLDivElement>, data: TabProps) => this.setState({
                        activeTab: data.activeIndex ? data.activeIndex : 0
                    })}
                    panes={panes}
                />
            </ViewContainer>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    modelYears: selectModelyears(state),
    userDetails: selectUserDetails(state),
    baseLinks: selectBaseLinks(state),
    client: selectClient(state),
    approvals: selectApprovals(state),
    cnrList: selectCnrList(state),
    typefamilyMap: selectTypefamilyMap(state),
    userLanguage: selectLanguage(state)
});

const mapDispatchToProps = (dispatch: Dispatch<any>): IMapDispatchToProps => ({
    addLoadingMessage: (message: string) => dispatch(GeneralActions.AddLoadingMessage(message)),
    removeLoadingMessage: (message: string) => dispatch(GeneralActions.RemoveLoadingMessage(message)),
    addTranslationLocation: (translation: ILocationTranslation) => dispatch(GeneralActions.AddTranslationLocation(translation)),
    ReceiveTranslationServiceAction: (translationService: any) => dispatch(GeneralActions.ReceiveTranslationServiceAction(translationService))
});

export default compose(
    translate(["MANAGEMENT_VIEW"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(ManagementView);



// WEBPACK FOOTER //
// ./src/views/ManagementView/ManagementView.tsx